<template lang="pug">
    .level-list
        .level-list__header
            span {{ level.theme }}
            span &nbsp;
            span.level-list__students-count {{ studentsList.length }}
        .level-list__students(v-if="studentsList.length")
            .level-list__student-line(v-for="student in firstStudents")
                .student-line__body
                    .student-line__item
                        small-user-preview(:displayed-user="student")
                            .student__city(slot="info")
                                svg-icon.city__icon(name="pin", size="base")
                                | {{ student.city }}
                    .student-line__item
                        cs-button(
                            v-if="user.isSuperadmin || user.isManagerOrSupport"
                            color="blue"
                            pattern="primary-outline"
                            narrow
                            @click="$emit('openChangeLevelModal', level, student)"
                        )
                            | {{ $i18n.t('olympiads.olympiads_studentsList_move') }}
        .level-list__empty(v-else) {{ $i18n.t('olympiads.olympiads_studentsList_nobodyRegistered') }}
        template(v-if="studentsList.length > studentsToShow")
            .students-list__show-all
                cs-button(
                    color="blue"
                    pattern="primary-outline",
                    @click="showList = !showList"
                    narrow
                )
                    svg-icon(v-if="isLoaded", :name="iconName", slot="icon")
                    span(v-text="$i18n.t('olympiads.olympiads_studentsList_seeAll')")
            transition(name="slide")
                .level-list__students(v-show="showList")
                    .level-list__student-line(v-for="student in anotherStudents")
                        .student-line__body
                            .student-line__item
                                small-user-preview(:displayed-user="student")
                                    .student__city(slot="info")
                                        svg-icon.city__icon(name="pin", size="base")
                                        | {{ student.city }}
                            .student-line__item
                                cs-button(
                                    v-if="user.isSuperadmin || user.isManagerOrSupport"
                                    color="blue"
                                    pattern="primary-outline"
                                    narrow
                                    @click="$emit('openChangeLevelModal', level, student)"
                                )
                                    | {{ $i18n.t('olympiads.olympiads_studentsList_move') }}
</template>

<script>
    import { mapState } from 'vuex';
    import usersListMixin from '../../../utils/user/usersListMixin';
    import SmallUserPreview from '../../profiles/default-elements/SmallUserPreview.vue';

    export default {
        components: { SmallUserPreview },
        mixins: [usersListMixin],
        props: {
            students: Array,
            searchParams: Object,
            level: Object,
        },
        data() {
            return {
                showList: false,
                isLoaded: true,
                studentsToShow: 6,
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            iconName() {
                return this.showList ? 'angle-up' : 'angle-down';
            },
            studentsList() {
                if (this.searchParams.grade) {
                    return this.students.filter(student => {
                        let gradesIds = student.grades.map(grade => grade.id);
                        if (gradesIds.includes(this.searchParams.grade.id)) {
                            if (this.searchParams.studentName) {
                                if (
                                    student.fullName
                                        .toLowerCase()
                                        .replace(/ё/g, 'е')
                                        .search(
                                            this.searchParams.studentName
                                                .trim()
                                                .toLowerCase()
                                                .replace(/ё/g, 'е')
                                        ) >= 0
                                ) {
                                    return student;
                                }
                                return false;
                            }
                            return student;
                        }
                    });
                }
                if (this.searchParams.school) {
                    return this.students.filter(student => {
                        let schoolsIds = student.schools.map(school => school.id);
                        if (schoolsIds.includes(this.searchParams.school.id)) {
                            if (this.searchParams.studentName) {
                                if (
                                    student.fullName
                                        .toLowerCase()
                                        .replace(/ё/g, 'е')
                                        .search(
                                            this.searchParams.studentName
                                                .trim()
                                                .toLowerCase()
                                                .replace(/ё/g, 'е')
                                        ) >= 0
                                ) {
                                    return student;
                                }
                                return false;
                            }
                            return student;
                        }
                    });
                }
                if (this.searchParams.studentName) {
                    return this.students.filter(student => {
                        if (
                            student.fullName
                                .toLowerCase()
                                .replace(/ё/g, 'е')
                                .search(
                                    this.searchParams.studentName
                                        .trim()
                                        .toLowerCase()
                                        .replace(/ё/g, 'е')
                                ) >= 0
                        ) {
                            return student;
                        }
                    });
                }
                return this.students;
            },
            firstStudents() {
                return this.studentsList.slice(0, this.studentsToShow);
            },
            anotherStudents() {
                return this.studentsList.slice(this.studentsToShow);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .level-list:not(:last-child) {
        margin-bottom: 64px;
    }

    .level-list__header {
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
        margin-bottom: 16px;
    }

    .level-list__students-count {
        color: $hsl-color-gray-51;
        font-weight: 400;
    }

    .level-list__student-line {
        border: 1px solid $x-color-gray-5;
        box-sizing: border-box;
        border-radius: 8px;
        margin: 8px 0;
    }

    .level-list__empty {
        font-size: 16px;
        line-height: 20px;
    }

    .student-line__body {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        margin: -8px;
    }

    .student-line__item {
        padding: 8px;
    }

    .student__city {
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
        color: $x-color-black;
        margin-top: 4px;
        pointer-events: none;
        display: flex;
        align-items: center;
    }

    .city__icon {
        color: $hsl-color-green-58;
        margin-right: 10px;
    }

    .students-list__show-all {
        display: flex;
        justify-content: center;
        margin: 16px 0;
    }
</style>

<style lang="scss" scoped>
    .slide-enter-active,
    .slide-leave-active {
        transition: max-height 1s;
        overflow: hidden;
    }
    .slide-enter,
    .slide-leave-to {
        max-height: 0;
    }
    .slide-enter-to,
    .slide-leave {
        max-height: 400px;
    }
</style>
